export const REGION_CODES = ["de", "ch", "at", "en"];

export const REGION_ROUTE_DEFINITIONS = [
  { key: "home", slug: "", sitemap: true },
  { key: "about", slug: "about", sitemap: true },
  { key: "abm", slug: "abm", sitemap: true },
  { key: "corporateInfluencer", slug: "corporate-influencer", sitemap: true },
  { key: "linkedinAds", slug: "linkedin-ads", sitemap: true },
  { key: "personalBranding", slug: "personal-branding", sitemap: true },
  { key: "hubspotRevops", slug: "hubspot-revops", sitemap: true },
  { key: "telemarketing", slug: "telemarketing", sitemap: true },
  // /en führt den englischen Slug, /de, /ch, /at den deutschen. Der jeweils
  // andere leitet per 301 weiter (public/_redirects, netlify.toml).
  { key: "mailKampagne", slug: "mail-kampagne", slugByRegion: { en: "mail-campaigns" }, sitemap: true },
  { key: "motionAi", slug: "motion-ai", sitemap: true },
  { key: "n8nAutomations", slug: "n8n-automations", sitemap: true },
  { key: "dmOutbound", slug: "dm-outbound", sitemap: true },
  { key: "ipTracking", slug: "ip-tracking", sitemap: true },
  { key: "einstiegsangebot", slug: "einstiegsangebot", sitemap: true },
  { key: "einstiegsangebotWelcome", slug: "einstiegsangebot/welcome", sitemap: false },
  { key: "booking", slug: "booking", sitemap: true },
  { key: "meetingConfirmed", slug: "meeting-confirmed", sitemap: false },
  { key: "meetingConfirmedExternal", slug: "meetingconfirmed", sitemap: false },
  { key: "webinare", slug: "webinare", sitemap: true },
  { key: "webinarConfirmed", slug: "webinar-confirmed", sitemap: false },
  { key: "impressum", slug: "impressum", sitemap: true },
  { key: "datenschutz", slug: "datenschutz", sitemap: true },
  { key: "revenueBlueprint", slug: "revenue-blueprint", sitemap: false },
  { key: "resources", slug: "resources", sitemap: true },
  { key: "caseStudies", slug: "case-studies", sitemap: true },
  { key: "caseStudyBSGroup", slug: "case-studies/bs-group", sitemap: true },
  { key: "caseStudyNeXenio", slug: "case-studies/nexenio", sitemap: true },
  { key: "caseStudySaasCrmPlattform", slug: "case-studies/saas-crm-plattform", sitemap: true },
  { key: "caseStudyCloud7", slug: "case-studies/cloud7", sitemap: true },
  { key: "partnerOrders", slug: "partnerbestellungen", sitemap: false },
];

/**
 * Kanonische URL einer Seite. Netlify liefert die prerenderten Seiten
 * (dirStyle "nested") unter der Variante mit Schrägstrich aus; Canonical,
 * Sitemap, hreflang und interne Links nennen deshalb genau diese Variante.
 */
export function getLocalizedPath(regionCode, slug = "") {
  return slug ? `/${regionCode}/${slug}/` : `/${regionCode}/`;
}

/** Hängt an einen Seitenpfad den Schrägstrich an (Dateien, Anker und Query bleiben unberührt). */
export function withTrailingSlash(path) {
  const match = path.match(/^([^?#]*)(.*)$/);
  const pathname = match[1];
  if (pathname === "" || pathname.endsWith("/") || /\.[a-z0-9]+$/i.test(pathname)) return path;
  return `${pathname}/${match[2]}`;
}

/** Slug einer Route in einer Region (z. B. mail-campaigns unter /en). */
export function slugFor(route, regionCode) {
  return route.slugByRegion?.[regionCode] ?? route.slug;
}

/** Route zu einem Slug, egal in welcher Sprachvariante er geschrieben ist. */
export function findRouteBySlug(slug) {
  return REGION_ROUTE_DEFINITIONS.find(
    (route) => route.slug === slug || Object.values(route.slugByRegion ?? {}).includes(slug),
  );
}

/** Übersetzt einen Pfad ohne Präfix ("/mail-kampagne#faq") in den Slug der Region. */
export function localizeSlug(regionCode, path) {
  const match = path.match(/^\/?([^?#]*?)\/?([?#].*)?$/);
  const slug = match?.[1] ?? "";
  const route = findRouteBySlug(slug);
  if (!route) return path;
  const localized = slugFor(route, regionCode);
  return `/${localized}${match?.[2] ?? ""}`;
}

/** Pfade für vite-react-ssg; die Router-Pfade selbst kommen ohne Schrägstrich. */
export function getPrerenderPaths() {
  const localizedPaths = REGION_CODES.flatMap((regionCode) =>
    REGION_ROUTE_DEFINITIONS.map((route) =>
      getLocalizedPath(regionCode, slugFor(route, regionCode)).replace(/\/$/, ""),
    ),
  );

  return ["/", ...localizedPaths];
}

export function getCanonicalLocalizedPaths() {
  return REGION_CODES.flatMap((regionCode) =>
    REGION_ROUTE_DEFINITIONS.filter((route) => route.sitemap).map((route) =>
      getLocalizedPath(regionCode, slugFor(route, regionCode)),
    ),
  );
}

/** Der Blog existiert nur unter /de: jede Sprachversion verlinkt dorthin. */
export const BLOG_PATH = "/de/blog/";
